import { rem } from 'polished'

export const TRIP_LIST_GRID_COLUMNS = `${rem(40)} minmax(${rem(280)}, 1fr) minmax(${rem(160)}, ${rem(240)}) minmax(${rem(112)}, ${rem(150)}) ${rem(112)} ${rem(40)}`
